import React from 'react'

export const defaultState = {
    hostUrl: '',
    gtmId: '',
    envValue: '',
    cloudinaryEnv: '',
    staticAssetCdnUrl: ''
}

export const EnvVariablesContext = React.createContext(defaultState)

const { Provider } = EnvVariablesContext

const EnvVariableProvider = ({ value, children }) => {

    return <Provider value={value}>{children}</Provider>

}

export default EnvVariableProvider